import { useConnectivityKeyMapping } from "@/hooks/useConnectivityKeyMapping";
import { IGetChargePointResponse, IOnboardingResponse } from "@/api/ApiTypes";
import { useMemo } from "react";
import { getHeaderTextByKey } from "@/utils/helpers";
import { connectivityIconWithKey } from "@steps/ConnectivityStatus/ConnectivityStatus";

type ConnectivityIconKeyType = typeof connectivityIconWithKey;

export const useChargePointData = (data: IOnboardingResponse) => {
  const connectivityKeyMappings = useConnectivityKeyMapping();

  const mapDataToChargePointData = (data: IGetChargePointResponse) => {
    return {
      vendor: data?.vendor || "-",
      model: data?.model || "-",
      chargePointSerialNumber: data?.chargePointSerialNumber || "-",
      chargeBoxSerialNumber: data?.chargeBoxSerialNumber || "-",
      firmwareVersion: data?.firmwareVersion || "-",
      connectionType: data?.connectionType || ("-" as null)
    };
  };

  const languageKeys: Array<keyof ConnectivityIconKeyType> = Object.keys(
    connectivityKeyMappings
  ) as Array<keyof ConnectivityIconKeyType>;

  const mappedData = mapDataToChargePointData(data?.chargePoint);

  return useMemo(
    () =>
      languageKeys.map((key) => {
        const { key: label } = getHeaderTextByKey(key, connectivityKeyMappings);
        return {
          label,
          value: mappedData[key],
          icon: connectivityIconWithKey[key]
        };
      }),
    [connectivityKeyMappings]
  );
};
